import { render, staticRenderFns } from "./MultiSelect.vue?vue&type=template&id=3667dda8&scoped=true&"
import script from "./MultiSelect.vue?vue&type=script&lang=js&"
export * from "./MultiSelect.vue?vue&type=script&lang=js&"
import style0 from "semantic-ui-label/label.css?vue&type=style&index=0&id=3667dda8&prod&scoped=true&lang=css&"
import style1 from "semantic-ui-dropdown/dropdown.css?vue&type=style&index=1&id=3667dda8&prod&scoped=true&lang=css&"
import style2 from "./MultiSelect.vue?vue&type=style&index=2&id=3667dda8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3667dda8",
  null
  
)

export default component.exports